import { render, staticRenderFns } from "./NormalList.vue?vue&type=template&id=0c6dd962&"
import script from "./NormalList.vue?vue&type=script&lang=js&"
export * from "./NormalList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports